import React from "react";
import { reduxForm } from "redux-form";
import { EDIT_VERSION_BLADE_FORM } from "forms/list";


import VariableRow from "./VariableRow";
// import NoSearch from "../NoSearch";

export function EditVersion(props){
	const {
		handleSubmit,
		onSave,
		libraryId,
		variables,
	} = props;


	return (
		<section className="refined-edit-variable-list">
			<form className="form" id={EDIT_VERSION_BLADE_FORM} onSubmit={handleSubmit(onSave)}>
				{variables.map((value) => {
					return (
						<VariableRow
							key={value.name}
							libraryId = {libraryId}
							{...value}
						/>
					);
				})}
			</form>
		</section>
	);
}

export default reduxForm({
	form: EDIT_VERSION_BLADE_FORM,
	destroyOnUnmount: false,
})(EditVersion);

EditVersion.displayName = "EditVersion";
